import { render, staticRenderFns } from "./mindOverMatter.vue?vue&type=template&id=171702f5&scoped=true&"
import script from "./mindOverMatter.vue?vue&type=script&lang=js&"
export * from "./mindOverMatter.vue?vue&type=script&lang=js&"
import style0 from "./mindOverMatter.vue?vue&type=style&index=0&id=171702f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171702f5",
  null
  
)

export default component.exports